import { IBlock } from 'common/builder/blocks/blockInterfaces'
import {
  getConditionNodeConditionGroup,
  GetConditionNodeConditionGroupsPayload,
} from 'common/builder/components/chart/FlowChart/adapters/generic/nodes/converterRules/helpers/getConditionNodeConditionGroup'
import { FlowChartConditionGroup } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartConditionNode'

/**
 * Iterates over Condition node blocks and return condition groups
 * as FlowChartConditionGroup to render them on the FlowChart
 */
export function getConditionNodeConditionGroups({
  blocks,
  ...payload
}: {
  blocks: IBlock[]
} & GetConditionNodeConditionGroupsPayload): FlowChartConditionGroup[] {
  return blocks
    .map((block) => getConditionNodeConditionGroup({ block, ...payload }))
    .filter((conditionGroup): conditionGroup is FlowChartConditionGroup => conditionGroup !== null)
}
